<ng-container *ngIf="isDesktop; else userMenuTemplate">
  <div class="dropdown">
    <ng-container *ngTemplateOutlet="userMenuTemplate"></ng-container>

    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
      <div class="dropdown-menu-arrow"></div>

      <div *ngIf="attendanceProtocol" class="attendance-protocol-container menu-container bottom-border">
        <ng-container *ngTemplateOutlet="attendanceProtocolTemplate"></ng-container>
      </div>

      <ng-container *ngFor="let item of userMenuItems">
        <li class="bottom-border">
          <a class="dropdown-item" [routerLink]="[item.url]">{{ item.label }}</a>
        </li>
      </ng-container>

      <li>
        <button class="dropdown-item" type="button" (click)="logout()">Sair</button>
      </li>
    </ul>
  </div>
</ng-container>

<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvas"
  aria-labelledby="userMenu"
>
  <div class="offcanvas-header" data-bs-dismiss="offcanvas">
    <div *ngIf="userInfo">
      <img class="user-picture" [src]="userInfo['picture']" alt="Foto">

      <span class="user-name">{{ userName }}</span>
    </div>

    <div class="arrow">
      <app-lucide-icon [iconName]="'chevron-right'"></app-lucide-icon>
    </div>
  </div>

  <div class="offcanvas-body">
    <div>
      <div *ngIf="attendanceProtocol" class="attendance-protocol-container offcanvas-container">
        <ng-container *ngTemplateOutlet="attendanceProtocolTemplate"></ng-container>
      </div>

      <span class="offcanvas-menu-title">Meu Menu</span>

      <ul class="offcanvas-list">
        <ng-container *ngFor="let item of accountMenuItems; let i = index">
          <li [class.bottom-border]="!isLastItem(accountMenuItems, i)">
            <a
              class="offcanvas-list-item"
              data-bs-dismiss="offcanvas"
              [routerLink]="[item.url]"
            >{{ item.label }}</a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="offcanvas-logout-container">
      <button
        class="offcanvas-logout-button"
        type="button"
        data-bs-dismiss="offcanvas"
        (click)="logout()"
      >Sair</button>
    </div>
  </div>
</div>


<ng-template #userMenuTemplate>
  <div
    [class.user-menu]="isUserAuthLoading || userInfo"
    id="userMenu"
    [attr.data-bs-toggle]="bsToggle"
    [attr.data-bs-target]="bsTarget"
    aria-expanded="false"
    aria-controls="offcanvas"
  >
    <ng-container *ngIf="isUserAuthLoading">
      <div class="user-picture">
        <app-loading-placeholder></app-loading-placeholder>
      </div>

      <div class="user-name-loading-placeholder">
        <app-loading-placeholder></app-loading-placeholder>
      </div>
    </ng-container>

    <ng-container *ngIf="!isUserAuthLoading">
      <ng-container *ngIf="userInfo">
        <img class="user-picture" [src]="userInfo['picture']" alt="Foto">

        <span *ngIf="isDesktop" class="user-name">{{ userName }}</span>

        <div class="arrow">
          <app-lucide-icon [iconName]="iconName"></app-lucide-icon>
        </div>
      </ng-container>

      <ng-container *ngIf="!userInfo">
        
        <ng-container *ngIf="isDesktop, else acessUserInfoIcon">
          <app-button [text]="'Acessar Conta'" [shortPadding]="true" [defaultHeight]="false" (clickEvent)="login()"></app-button>
        </ng-container>
        <ng-template #acessUserInfoIcon>
          <div class="acess-user-info-icon" (click)="login()">
            <app-lucide-icon [iconName]="'circle-user'" [size]="25"></app-lucide-icon>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #attendanceProtocolTemplate>
  <span class="attendance-protocol title">Protocolo de Atendimento:</span>

  <div class="attendance-protocol-bottom-container">
    <div class="attendance-protocol-text-container">
      <span class="attendance-protocol">{{ attendanceProtocol }}</span>
    </div>

    <div class="attendance-protocol-button" (click)="handleCopyProtocolButtonClick()">
      <app-lucide-icon [iconName]="'copy'" [color]="'darkGray'" [size]="20"></app-lucide-icon>
    </div>
  </div>
</ng-template>
